(function () {
  if (window.__featuredProductCarouselReady) return;
  window.__featuredProductCarouselReady = true;

  var initializedAttribute = 'data-featured-product-carousel-initialized';

  function initCarousel(element) {
    if (!element || element.hasAttribute(initializedAttribute)) return;
    if (typeof window.Flickity !== 'function') return;

    element.setAttribute(initializedAttribute, 'true');

    new Flickity(element, {
      cellAlign: 'left',
      contain: true,
      groupCells: true,
      wrapAround: true
    });
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.grid-dev__slide').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
